module.exports = __webpack_public_path__ + "img/data-analysis.32aa0cb3.png";